import { render } from "./PaymentConfig.vue?vue&type=template&id=d66bf4ce&scoped=true"
import script from "./PaymentConfig.vue?vue&type=script&lang=js"
export * from "./PaymentConfig.vue?vue&type=script&lang=js"

import "./PaymentConfig.vue?vue&type=style&index=0&id=d66bf4ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d66bf4ce"]])

export default __exports__